<div class="card" *ngIf="selected">
  <div class="card-body">
    <h4 class="card-title">Info generali</h4>
    <div class="row">
      <div class="col-lg-4 form-group">
        <label class="mb-0 text-dark">Titolo</label>
        <input type="text" required #nome="ngModel" [(ngModel)]="selected.nome" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!nome.valid && (nome.dirty || nome.touched)">Titolo richiesto</small>
      </div>
      <div class="col-lg-4 form-group">
        <label class="mb-0 text-dark">Inizio</label>
        <input type="datetime-local" required #data_inizio_prevista="ngModel" [(ngModel)]="selected.data_inizio_prevista" name="data_inizio_prevista" class="form-control">
        <small class="form-text text-danger" *ngIf="!data_inizio_prevista.valid && (data_inizio_prevista.dirty || data_inizio_prevista.touched)">data_inizio_prevista richiesta</small>
      </div>
      <div class="col-lg-4 form-group">
        <label class="mb-0 text-dark">Fine</label>
        <input type="datetime-local" required #data_fine_prevista="ngModel" [(ngModel)]="selected.data_fine_prevista" name="data_fine_prevista" class="form-control">
        <small class="form-text text-danger" *ngIf="!data_fine_prevista.valid && (data_fine_prevista.dirty || data_fine_prevista.touched)">data_fine_prevista richiesto</small>
      </div>
      <div class="col-4" *ngIf="!selected.id">
        <label for="categorie" class="control-label col-form-label">Categorie:</label>
        <ng-multiselect-dropdown [settings]="categoriedropdownSettings" style="width: 80%; " [placeholder]="'Seleziona'" id="categorie"
                                 [data]="CategorieLineare" [(ngModel)]="CategorieSelezionate" (ngModelChange)="catChanged()"
                                 (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-3">
        <label for="manager" class="control-label col-form-label">{{'Scadenza.manager' | translate}}: *</label>
        <ng-multiselect-dropdown [settings]="userDropdownSettings" [placeholder]="'Scadenza.manager' | translate" id="manager" [data]="managers" [(ngModel)]="selectedManagers" (onFilterChange)="managerFilter($event)" >
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-12 form-group">
        <label class="mb-0 text-dark">Note</label>
        <textarea class="form-control" [(ngModel)]="selected.note"></textarea>
      </div>
      <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>
    </div>
  </div>
</div>
<div class="card" *ngIf="selected">
  <div class="card-body">
    <h4 class="card-title">Dati Cantiere</h4>
    <div class="row">
      <div class="col-lg-3">
        <label for="cliente" class="control-label col-form-label">{{'Valutazione.cliente' | translate}}: </label>
        <ng-multiselect-dropdown [settings]="clienteDropdownSettings" [placeholder]="'Valutazione.cliente' | translate" id="cliente"  [data]="clienti" [(ngModel)]="clientiSelezionati" (onFilterChange)="ClientFilter($event)" (ngModelChange)="clienteChange()" >
        </ng-multiselect-dropdown>
      </div>
    </div>
    <div class="row" >
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Nominativo</label>
        <input type="text" required #nominativo="ngModel" [(ngModel)]="selected.nominativo" name="nominativo"
          class="form-control">
        <small class="form-text text-danger"
          *ngIf="!nominativo.valid && (nominativo.dirty || nominativo.touched)">Nominativo
          richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Indirizzo</label>
        <input type="text" required #indirizzo="ngModel" [(ngModel)]="selected.indirizzo" name="indirizzo"
          class="form-control">
        <small class="form-text text-danger"
          *ngIf="!indirizzo.valid && (indirizzo.dirty || indirizzo.touched)">Indirizzo
          richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Cap</label>
        <input type="text" required #cap="ngModel" [(ngModel)]="selected.cap" name="cap" class="form-control">
        <small class="form-text text-danger" *ngIf="!cap.valid && (cap.dirty || cap.touched)">cap richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Città</label>
        <input type="text" required #citta="ngModel" [(ngModel)]="selected.citta" name="citta"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!citta.valid && (citta.dirty || citta.touched)">citta
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Provincia</label>
        <input type="text" required #provincia="ngModel" [(ngModel)]="selected.provincia" name="provincia"
          class="form-control">
        <small class="form-text text-danger"
          *ngIf="!provincia.valid && (provincia.dirty || provincia.touched)">provincia
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Regione</label>
        <input type="text" #regione="ngModel" [(ngModel)]="selected.regione" name="regione"
               class="form-control">
        <small class="form-text text-danger" *ngIf="!regione.valid && (regione.dirty || regione.touched)">regione
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Nazione</label>
        <input type="text" #nazione="ngModel" [(ngModel)]="selected.nazione" name="nazione"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!nazione.valid && (nazione.dirty || nazione.touched)">nazione
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">E-Mail</label>
        <input type="text" #email="ngModel" [(ngModel)]="selected.email" name="email"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!email.valid && (email.dirty || email.touched)">email
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Fax</label>
        <input type="text" #fax="ngModel" [(ngModel)]="selected.fax" name="fax"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!fax.valid && (fax.dirty || fax.touched)">fax
          richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Telefono</label>
        <input type="text" #tel="ngModel" [(ngModel)]="selected.telefono" name="tel" class="form-control">
        <small class="form-text text-danger" *ngIf="!tel.valid && (tel.dirty || tel.touched)">telefono
          richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Pec</label>
        <input type="text" #pec="ngModel" [(ngModel)]="selected.pec" name="pec"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!pec.valid && (pec.dirty || pec.touched)">pec
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">codice_univoco</label>
        <input type="text" #codice_univoco="ngModel" [(ngModel)]="selected.codice_univoco" name="codice_univoco"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!codice_univoco.valid && (codice_univoco.dirty || codice_univoco.touched)">pec
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Part. IVA</label>
        <input type="text" #piva="ngModel" [(ngModel)]="selected.piva" name="piva"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!piva.valid && (piva.dirty || piva.touched)">pec
          richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Codice Fiscale</label>
        <input type="text" #cf="ngModel" [(ngModel)]="selected.cf" name="cf"
          class="form-control">
        <small class="form-text text-danger" *ngIf="!cf.valid && (cf.dirty || cf.touched)">cf
          richiesto</small>
      </div>

    </div>
  </div>
</div>
<div class="card" *ngIf="selected">
  <div class="card-body">
    <h4 class="card-title">Personale</h4>
    <app-employees [Employees]="selected.employers"></app-employees>
  </div>
</div>
<app-check-list-valutazione *ngIf="selected && selected.id" [Selected]="selected.checks" [valutazione]="selected"></app-check-list-valutazione>
<div *ngIf="selected && selected.id" class="card" >
  <app-file-uploader [url]="'/task/task/file'" [(id)]="selected.id" (onChange)="onFileChanged()"></app-file-uploader>
</div>

<aside class="customizer"  *ngIf="selected">
  <div style="position: absolute; bottom: 20px; left: -100px; ">
    <div class="d-md-flex align-items-center justify-content-end">
      <button type="submit" (click)="saveClick()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-sm "></i-feather>
      </button>
    </div>
  </div>
</aside>
